const stats = [
  {
    value: '92%',
    label: 'Improved Self-Awareness',
  },
  {
    value: '7.2x',
    label: 'Growth Rate',
  },
  {
    value: '120K',
    label: 'Assessments Completed',
  },
];

export function ImpactSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-success-40">
      <div className="max-w-[1216px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-heading-sm font-bold text-white mb-2">
            Our Impact So Far
          </h2>
          <p className="text-success-10 text-paragraph-lg max-w-xl mx-auto">
            Human Potential OS is helping thousands discover their true potential and achieve breakthrough results in their personal and professional lives.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-5xl md:text-6xl font-bold text-white mb-2">
                {stat.value}
              </p>
              <p className="text-success-10 font-medium">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
